<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="provider">Provedor</label>
        <b-form-select
          id="provider-select"
          class="w-100"
          v-model="type"
          :options="types"
          required
        ></b-form-select>
      </div>
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="provider">Modo</label>
        <b-form-select
          id="mode-select"
          class="w-100"
          v-model="active"
          :options="modes"
          required
        ></b-form-select>
      </div>
      <div
        class="d-flex flex-column items-start justify-content-between sizing-width"
      >
        <label for="number">Número</label>
        <v-select
          v-model="number"
          :options="listNumber"
          :reduce="x => x.value"
          class="w-100"
          label="text"
        >
          <template v-slot:no-options>{{
            $lang.Common.PlaceholderSelect
          }}</template>
        </v-select>
      </div>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import DropDownMensagensAutomaticas from '../../mensagensautomaticas/components/dropdown/DropDownMensagensAutomaticas.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import defaultbutton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'SidebarQuadro',
  components: {
    SidebarSearch,
    DropDownMensagensAutomaticas,
    defaultbutton
  },
  data () {
    return {
      active: null,
      type: null,
      number: null,
      listNumber: []
    }
  },
  async created () {
    const response = await NumRepository.getNumberAll()
    this.listNumber = response.data.numbers
  },
  methods: {
    clearForm () {
      this.active = null
      this.number = null
      this.type = null
      this.submitForm()
    },
    async submitForm () {
      const requestConfig = {
        params: {
          active: this.active,
          type: this.type,
          number: this.number
        }
      }
      console.log(requestConfig)
      try {
        if (this.active === null && this.number === null && this.type === null) {
          const res = await NumRepository.getEnvAll()
          this.$emit('filter', res.data.content)
        } else {
          const res = await NumRepository.getEnvAll(requestConfig)
          this.$emit('filter', res.data.content)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    addModal () {
      this.$emit('clicked-open')
    }
  },
  computed: {
    types () {
      return [
        {
          text: 'Meta',
          value: 'WHATS_META'
        },
        {
          text: 'Whatsapp',
          value: 'WHATS_WPP'
        }
      ]
    },
    modes () {
      return [
        {
          text: 'Ativo',
          value: 1
        },
        {
          text: 'Desativado',
          value: 0
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/filter/SidebarProvedor.vue